import React, { useEffect, useState } from "react";
// import Mesh from "../assets/images/BGmesh.svg";
import Mesh from "../../assets/images/BGmesh2.svg";
// import icon from "../assets/images/PurpleLogoIcon.svg";
import FinanceFeature from "../../assets/images/FinanceFeature.svg";

const Section2 = () => {
  const [windowWidth, setWindowWidth] = useState(null);
  const [lg, setLg] = useState(false);
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    if (firstRender) {
      setWindowWidth(window.innerWidth);
      setLg(Boolean(window.innerWidth > 1023));
      setFirstRender(false);
    }
  }, []);
  return (

    <section
  className="tw-max-w-[100vw] tw-bg-[15rem_0] tw-bg-[length:100vw] tw-bg-no-repeat"
  style={{ backgroundImage: `url(${Mesh})` }}
>
  <div className="tw-pt-10 lg:tw-py-10">
    <div className="tw-mx-7 lg:tw-mx-10 xl:tw-mx-14 2xl:tw-mx-32">
      <div className="lg:tw-ps-7 2xl:tw-ps-12">
        <div className="lg:tw-w-[53rem] 2xl:tw-w-[75rem]">
          <div className="ProductSansBold lg:tw-border-l-2 tw-border-[#9925df] xs:tw-ps-4 2xl:tw-ps-7 lg:tw-w-[53rem] 2xl:tw-w-[75rem]">
            <h1 className="tw-text-[22px] 2xl:tw-text-[27px] tw-text-[#062533] tw-leading-[1] tw-tracking-wider tw-w-fit">
              EMPOWER YOUR BUSINESS WITH ROBUST AND POWERFUL ERP SOLUTION
            </h1>
            <h2 className="2xl:tw-text-[21px] ProductSansMedium xl:ProductSansRegular tw-text-[#9925df] tw-leading-[1] tw-tracking-[0.001em] tw-mt-3 3xl:tw-mt-6 tw-w-fit">
              Higly integrated | Self Audited | Centralised Accounting |
              E-invoicing | E-way bills | Customised Dasboards | Reports |
            </h2>
          </div>
          <p className="xs:tw-ps-6 tw-text-[#4D4D50] tw-mt-4 ProductSansMedium tw-tracking-[-0.015em] 2xl:tw-tracking-wide tw-leading-[1.5]">
            In today's fast-paced digital landscape, organizations must
            prioritize rapid innovation for sustained growth. Crucial to gaining
            a competitive edge is leveraging "insight" - not only from standard
            reports and data but also from real-time analytics spanning your
            entire organization and business reports.
          </p>
        </div>
      </div>
      <div className="tw-pb-10 lg:tw-py-28 tw-relative">
        <div className="tw-w-fit tw-mx-auto tw-relative tw-mt-10 lg:tw-my-10 max-lg:tw-flex tw-flex-wrap tw-justify-center tw-gap-[3vw]">
          <img
            className="tw-w-[28rem] xl:tw-w-[35rem] 2xl:tw-w-[40rem] tw-hidden lg:tw-block"
            src={FinanceFeature}
            alt=""
          />
          <div
            className={`${
              lg
                ? "tw-absolute tw-top-[0] tw-right-0 tw-translate-x-[40%] tw-translate-y-[-140%]"
                : "tw-text-black tw-w-full xs:tw-w-[22rem]"
            }`}
          >
            <div className="tw-flex">
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
                01
              </h3>
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
                <span className="tw-text-[#9925df]">DATA</span> ACCURACY
              </h3>
            </div>
            <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-52">
              Gain immediate insight into every facet of your business data.
            </p>
          </div>
          <div
            className={`${
              lg
                ? "tw-absolute tw-top-[10%] tw-right-0 tw-translate-x-[110%] xl:tw-translate-x-[120%]"
                : "tw-text-black tw-w-full xs:tw-w-[22rem]"
            }`}
          >
            <div className="tw-flex">
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
                02
              </h3>
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
                <span className="tw-text-[#9925df]">DASHBOARD</span>{" "}
                {lg && <br />} & REPORTS
              </h3>
            </div>
            <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-44">
              Comprehensive dashboard and detailed reports for enhanced ERP
              performance and insights.
            </p>
          </div>
          <div
            className={`${
              lg
                ? "tw-absolute tw-bottom-[20%] tw-right-0 tw-translate-x-[120%]"
                : "tw-text-black tw-w-full xs:tw-w-[22rem]"
            }`}
          >
            <div className="tw-flex">
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
                03
              </h3>
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
                <span className="tw-text-[#9925df]">IMPLEMENTATION</span>{" "}
                {lg && <br />} SUPPORT
              </h3>
            </div>
            <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-44">
              Our domain experts assist you in implementing your business
              processes, ensuring a smooth transition as you adopt our ERP
              solution
            </p>
          </div>
          <div
            className={`${
              lg
                ? "tw-absolute tw-bottom-0 tw-right-0 tw-translate-x-[85%] xl:tw-translate-x-[45%] tw-translate-y-[100%] xl:tw-translate-y-[120%]"
                : "tw-text-black tw-w-full xs:tw-w-[22rem]"
            }`}
          >
            <div className="tw-flex">
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
                04
              </h3>
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
                <span className="tw-text-[#9925df]">GST & VAT</span>{" "}
                {lg && <br />} COMPLIANCE
              </h3>
            </div>
            <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-44">
              Finanzz possesses the capability for E-invoicing, E-way Billing,
              and efficiently manages VAT taxation for various countries.
            </p>
          </div>
          <div
            className={`${
              lg
                ? "tw-absolute tw-bottom-0 tw-left-0 tw-translate-x-[5%] xl:tw-translate-x-[25%]  tw-translate-y-[110%] xl:tw-translate-y-[120%]"
                : "tw-text-black tw-w-full xs:tw-w-[22rem]"
            }`}
          >
            <div className="tw-flex">
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
                05
              </h3>
              <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
                <span className="tw-text-[#9925df]">DATA SECURITY</span>{" "}
                {lg && <br />} & PRIVACY
              </h3>
            </div>
            <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-80">
              Finanzz ERP places a strong emphasis on robust security measures
              to safeguard data and manage user roles effectively. ensures the
              protection and privacy of your data both within and outside the
              organization, utilizing user access management protocols.
            </p>
          </div>
          <div
  className={`${
    lg
      ? "tw-absolute tw-bottom-[5%] tw-left-0 tw-translate-x-[-95%] xl:tw-translate-x-[-80%]"
      : "tw-text-black tw-w-full xs:tw-w-[22rem]"
  }`}
>
  <div className="tw-flex">
    <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
      06
    </h3>
    <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
      <span className="tw-text-[#9925df]">INTEGRATED</span> {lg && <br />}
      WORKFLOWS
    </h3>
  </div>
  <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-44">
    Streamlined workflows seamlessly integrated for enhanced organizational
    efficiency.
  </p>
</div>
<div
  className={`${
    lg
      ? "tw-absolute tw-top-[25%] tw-left-0 tw-translate-x-[-105%] xl:tw-translate-x-[-110%]"
      : "tw-text-black tw-w-full xs:tw-w-[22rem]"
  }`}
>
  <div className="tw-flex">
    <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
      07
    </h3>
    <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
      <span className="tw-text-[#9925df]">SEAMLESS</span> {lg && <br />}
      MIGRATION
    </h3>
  </div>
  <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-44">
    Effortlessly customize your ERP stack to incorporate a blend of SaaS,
    private cloud, and on-premise solutions tailored to your organization's
    requirements.
  </p>
</div>
<div
  className={`${
    lg
      ? "tw-absolute tw-top-0 tw-left-0 tw-translate-x-[-50%] tw-translate-y-[-40%]"
      : "tw-text-black tw-w-full xs:tw-w-[22rem]"
  }`}
>
  <div className="tw-flex">
    <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-leading-[1.15]">
      08
    </h3>
    <h3 className="tw-pb-1 ProductSansBold tw-text-[17px] tw-ps-1 lg:tw-ps-2 tw-leading-[1.15]">
      <span className="tw-text-[#9925df]">INDUSTRY SOLUTION</span> {lg && <br />}
      BEST PRACTICES
    </h3>
  </div>
  <p className="tw-text-[#4D4D50] tw-pt-1 tw-text-[11px] ProductSansMedium tw-border-t-[1px] tw-border-[#9925df] lg:tw-max-w-64">
    Tailored to fit any industry domain while adhering to the industry best
    practices and future trends.
  </p>
</div>


        </div>
      </div>
    </div>
  </div>
</section>
 );
};

export default Section2;
